import { useEffect } from "react";

// Canonical/OG URLs always point to the live production domain (not the preview host).
const SITE = "https://mymetros.co.uk";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Injects (or removes) a JSON-LD structured-data <script> block, keyed by id.
export function useJsonLd(id, data) {
  useEffect(() => {
    const elId = `ld-${id}`;
    let el = document.getElementById(elId);
    if (!data) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = elId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  }, [id, data]);
}

// Sets per-page title / description / keywords / canonical / robots + Open Graph & Twitter tags.
export function useSeo({ title, description, keywords, path = "", noindex = false, image }) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertLink("canonical", url);
    if (image) {
      upsertMeta("property", "og:image", image);
      upsertMeta("name", "twitter:image", image);
    }
  }, [title, description, keywords, path, noindex, image]);
}
